import branches from './branches';

export const addons = { branches };
